import { fetchAPI } from "@/utils/fetchAPI";

export type ProductName =
  | "Forfait avec Engagement"
  | "Gestion+ avec Engagement"
  | "Saisie PREMIER"
  | "Gestion+"
  | "eCofiCoffre";

export type CofidocBilling = {
  id?: number;
  date?: Date;
  reference?: string;
  amount?: string;
};

type FetchCofidocBillParams = {
  id: string | number;
  username?: string | null;
  email?: string | null;
  application?: any;
};

export async function fetchCofidocBill({ id, username, email, application }: FetchCofidocBillParams) {
  try {
    const queryParams = new URLSearchParams();
    if (username) queryParams.append("username", username);
    if (email) queryParams.append("email", email);

    const queryString = queryParams.toString();
    const url = `/account/bills/${id}${queryString ? `?${queryString}` : ""}`;

    const res = await fetchAPI({
      url,
      options: {
        method: "GET",
      },
      application,
    });

    return res;
  } catch (error) {
    throw new Error();
  }
}
